<!--
 * @Author: cmchiu
 * @Date: 2023-04-13 14:28:46
 * @LastEditTime: 2023-05-10 14:01:57
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \IACMP\IACMP_Client\src\views\post.vue
 * 
-->
<template>
    <div class="post">
        <breadcrumb :title="post && post.length > 0 ? post[0].ItemTitle : null" />

        <div class="layer-container">
            <div class="news-inner" v-for="data in post" :key="data.sno">
                <p class="news-inner__release">
                    <span class="news-inner__date" v-text="data.UpdDate ? data.UpdDate.substr(0, 10) : 'N/A'"></span>
                    {{ data.UpdOprName }}
                </p>
                <h2 class="news-inner__title" v-text="data.ItemTitle"></h2>
                <div class="news-inner__section">
                    <div class="post-image" v-if="data.ItemImages && data.ItemImages.length > 0">
                        <img
                            class="news-inner__img"
                            :src="data.ItemImages[0].location"
                            :alt="data.ItemImages[0].name"
                        />
                    </div>
                    <div class="post-content news-inner__text" v-html="data.ItemContent"></div>
                </div>
                <div class="post-attachments" v-if="data.ItemFiles && data.ItemFiles.length > 0">
                    附件檔案：
                    <ul>
                        <li v-for="(file, index) in data.ItemFiles" :key="index">
                            <a :href="file.location" target="_blank" v-text="file.name"></a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- <div v-for="data in post" :key="data.sno">
            <h3 v-text="data.ItemTitle"></h3>
            <h4 v-if="data.ItemSubTitle" v-text="data.ItemSubTitle"></h4>
            <div class="post-date">
                發布日期：<span v-text="data.UpdDate ? data.UpdDate.substr(0, 10) : 'N/A'"></span>
            </div>
            <div class="post-image" v-if="data.ItemImages && data.ItemImages.length > 0">
                <img :src="data.ItemImages[0].location" :alt="data.ItemImages[0].name" />
            </div>
            <div class="post-content" v-html="data.ItemContent"></div>
            <div class="post-attachments" v-if="data.ItemFiles && data.ItemFiles.length > 0">
                附件檔案：
                <ul>
                    <li v-for="(file, index) in data.ItemFiles" :key="index">
                        <a :href="file.location" target="_blank" v-text="file.name"></a>
                    </li>
                </ul>
            </div>
        </div> -->
    </div>
</template>

<script>
import XEUtils from 'xe-utils'
import { getItemContent } from '@/api/common'
import { breadcrumb } from '@c'

export default {
    name: 'post',

    components: { breadcrumb },

    data() {
        return {
            configs: {
                loading: false,
            },
            MenuID: this.$route.query.id,
            SNO: this.$route.query.sno,
            post: [],
        }
    },

    created() {
        this.getMenuItemLs()
    },

    methods: {
        async getMenuItemLs(chgFilters) {
            const vm = this
            vm.configs.loading = true
            if (chgFilters) vm.menuItem.pages.pageCurrent = 1 //當條件改變時, 將當前頁次改回第1頁
            let params = {
                MenuID: vm.MenuID,
                SNO: vm.SNO,
                // ItemStatus: vm.menuItem.filter.status,
                // Keyword: vm.menuItem.filter.keyword,
                // PageSize: vm.menuItem.pages.pageSize,
                // PageCurrent: vm.menuItem.pages.pageCurrent,
            }
            await getItemContent(params)
                .then(res => {
                    // handle success
                    vm.post = [] //res.Items
                    XEUtils.arrayEach(res.Items, item => {
                        item.ItemImages = JSON.parse(item.ItemImages)
                        item.ItemFiles = JSON.parse(item.ItemFiles)
                        vm.post.push(item)
                    })
                    // let pages = vm.menuItem.pages
                    // pages.totalResult = res.TotalResult
                    // if (Math.ceil(pages.totalResult / pages.pageSize) < pages.pageCurrent) {
                    //     pages.pageCurrent = 1
                    // }
                })
                .catch(err => {
                    // handle error
                    vm.post = []
                    console.log(err)
                })
                .finally(() => {
                    // always executed
                    vm.configs.loading = false
                })
        },
    },
}
</script>

<style scoped lang="scss"></style>
